// First level
export const HOME_SLUG = '/';
export const ABOUT_SLUG = '/about';
export const RESOURCES_SLUG = '/resources';
export const ABOUT_CONTACT_SLUG = '/about/contact';
export const AGENCY_LIST_SLUG = '/agencies';
export const FIND_A_STOP_SLUG = '/stops';
export const STATEWIDE_DATA = '/agencies/-1'; // -1 is NC State's static ID in DB

// Second level
export const AGENCY_DATA_SLUG = '/:agencyId/*';

// Third level
export const OVERVIEW_SLUG = '';
export const TRAFFIC_STOPS_SLUG = '/traffic-stops';
export const SEARCHES_SLUG = '/searches';
export const SEARCH_RATE_SLUG = '/search-rate';
export const CONTRABAND_SLUG = '/contraband';
export const USE_OF_FORCE_SLUG = '/use-of-force';
export const ARREST_SLUG = '/arrests';
